import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Section } from './shared';
const modules = [{
  emoji: '📘',
  title: 'Módulo 1 — El Agente que Cierra',
  text: 'Mentalidad de cierre, configuración de IA para seguros, protocolo de primera consulta, matriz de detección de necesidades del cliente.'
}, {
  emoji: '📗',
  title: 'Módulo 2 — Sistema de Seguimiento Inteligente',
  text: 'Scripts de seguimiento con IA, sistema de recordatorios automáticos, protocolo de renovaciones, mensajes listos para recuperar clientes indecisos.'
}, {
  emoji: '📙',
  title: 'Módulo 3 — Cierre de Objeciones PRO',
  text: "Los 10 guiones para las objeciones más comunes, técnica de anclaje de precio, respuestas para el cliente que 'lo piensa', sistema de cierre en 3 pasos."
}, {
  emoji: '📕',
  title: 'Módulo 4 — Gestión de Clientes Sin Estrés',
  text: 'Protocolo de WhatsApp Business PRO, sistema de etiquetas A/B/C, regla de las 24 horas, kit de bienvenida para nuevos clientes, guiones para situaciones difíciles.'
}, {
  emoji: '📓',
  title: 'Módulo 5 — Automatización de Trámites con IA',
  text: 'Sistema de carga de documentación automatizada, prompts para redactar mails profesionales, plantillas para comunicación con aseguradoras, checklist de cierre de póliza.'
}, {
  emoji: '📔',
  title: 'Módulo 6 — El Agente del Futuro · Plan 90 Días',
  text: 'Auditoría de tu cartera actual, 5 hábitos diarios de un agente exitoso, sistema de referidos en 3 pasos, estrategia de contenido en Instagram, plan de crecimiento de cartera.'
}];
const includes = ['Objetivos claros por capítulo', 'Scripts listos para copiar y pegar', 'Casos prácticos del contexto argentino', 'Checklists de implementación inmediata', '100% adaptados al mercado argentino: SSN, aseguradoras locales y la jerga de tus clientes.'];
export function Product() {
  return <Section id="modulos" className="bg-white py-16 sm:py-24" data-id="element-166" data-mp="ayvpum9xb910">
      <div className="text-center" data-id="element-167" data-mp="2b2eoy9lqh9eg">
        <span className="inline-block rounded-md bg-navy px-3 py-1 font-display text-sm font-bold tracking-wide text-gold-soft" data-id="element-168" data-mp="2b1ddw54pwmwq">
          LIBROFY.STORE™
        </span>
        <h2 className="mt-5 font-display text-2xl font-extrabold text-navy sm:text-4xl" data-id="element-169" data-mp="2krg45xkgfmrd">
          MEGAPACK AGENTES DE SEGUROS PRO
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-base text-slate-600 sm:text-lg" data-id="element-170" data-mp="2ppzqhz2yn0k9">
          Todo el sistema listo para transformar tu manera de trabajar.
        </p>
      </div>

      <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-171" data-mp="1x2wxfmh1zi1e">
        {modules.map(m => <div key={m.title} className="flex h-full flex-col rounded-2xl border border-slate-200 bg-slate-50 p-6 transition-shadow hover:shadow-md" data-id="element-172" data-mp="220f4167lll68">
            <div className="text-4xl" aria-hidden="true" data-id="element-173" data-mp="3dfc030279an3">
              {m.emoji}
            </div>
            <h3 className="mt-4 font-display text-lg font-bold text-navy" data-id="element-174" data-mp="3hgxl58ow0v8d">{m.title}</h3>
            <p className="mt-2 text-[15px] leading-relaxed text-slate-600" data-id="element-175" data-mp="15uvdy2hcsoyt">{m.text}</p>
          </div>)}
      </div>

      <div className="mt-12 rounded-2xl border border-slate-200 bg-navy p-7 text-white sm:p-9" data-id="element-176" data-mp="11tjvcgwwd404">
        <h3 className="font-display text-lg font-bold text-gold-soft" data-id="element-177" data-mp="x10f1c6trurm">Cada módulo incluye</h3>
        <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-178" data-mp="s2fflezedf48">
          {includes.map(item => <li key={item} className="flex items-start gap-3 text-[15px] text-blue-50" data-id="element-179" data-mp="n56zdjxt7l5m">
              <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-180" data-mp="i4rhqg6hvrhu" />
              <span data-id="element-181" data-mp="e2nw4yq436iu">{item}</span>
            </li>)}
        </ul>
      </div>
    </Section>;
}